import React from "react";
import "./searchList.scss";

const ProductsSearchList = ({ products, onSelectProductHandler }) => {
    return (
        <div className="searchList">
            <ul className="list-group">
                {products?.map((product) => {
                    return (
                        <li
                            className="list-group-item custom-list-item"
                            key={product?.id}
                            onClick={() => onSelectProductHandler(product)}
                        >
                            <div>
                                {product?.title} ({product?.imei_sn})
                            </div>
                            <div>
                                <span className="text-primary">{product?.price} грн.</span>{" "}
                                <span className="text-warning fw-bold">{product?.store?.title}</span>
                            </div>
                        </li>
                    );
                })}
            </ul>
        </div>
    );
};

export default ProductsSearchList;
